<template>
  <section class="h-partnership" ref="scroll5">
    <div class="container">
      <ScreenTitle center>Partnership</ScreenTitle>
      <p class="h-partnership__title text-l font-400">Building Collaborative Success</p>
      <div class="h-partnership__content flex flex-wrap">
        <PartnerCard
          v-for="(item, index) in partners"
          :key="index"
          :img="item.img"
          :id="`p${index+1}`"
          :title="item.title"
          :text="item.text"
          :visible="visible && visibleCnt === 1 && blocks[index].cnt == 1 && blocks[index].visible"
          :hide="(visibleCnt === 1 || visibleCnt === 0) && blocks[index].cnt === 0"
        ></PartnerCard>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import ScreenTitle from "@/components/common/ScreenTitle.vue";
import PartnerCard from "@/components/common/PartnerCard.vue";
import { PARTNERS } from "@/constant/partners.js";
import {isElementVisible} from "@/visibility";

const props = defineProps({
  visibleCnt: Number,
  hide: Boolean,
  visible: Boolean
})

const blocks = ref(Array.from({ length: 5 }, () => ({ id: null, visible: false, cnt: 0 })));
const partners = ref(PARTNERS);

const handleScroll = () => {
  blocks.value.forEach((block) => {
    const element = document.getElementById(block.id);
    if (!!element) {
      const isVisible = isElementVisible(element, 0);
      if (isVisible && !block.visible) {
        block.visible = true;
        block.cnt = block.cnt + 1;
      } else if (!isVisible && block.visible) {
        block.visible = false;
      }
    }
  });
};

onMounted(() => {
  blocks.value.forEach((block, index) => {
    block.id = `p${index + 1}`;
  });
  handleScroll();
  window.addEventListener('scroll', handleScroll);
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style lang="scss">
.h-partnership {
  padding: 40px 0 110px;
  &__title {
    width: 100%;
    max-width: 995px;
    text-align: center;
    margin: 36px auto 0;
  }
  &__content {
    column-gap: 70px;
    row-gap: 60px;
    margin-top: 90px;
  }
}

@media (max-width: 1024px) {
  .h-partnership {
    &__content {
      flex-wrap: wrap;
    }
  }
}

@media (max-width: 768px) {
  .h-partnership {
    padding: 40px 0 60px;
    &__content {
      margin-top: 40px;
      gap: 40px;
    }
  }
}
</style>